// removed by extract-text-webpack-plugin
module.exports = {"BookServiceForm":"BookServiceForm__BookServiceForm___3Mze8","BookServiceFormForm":"BookServiceForm__BookServiceFormForm___2TX2y","ServiceSummary":"BookServiceForm__ServiceSummary___3nI8m","ServiceSummaryPrice":"BookServiceForm__ServiceSummaryPrice___2OckN"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/BookServiceForm/BookServiceForm.less
// module id = 423
// module chunks = 0 1